import React, { useEffect, useState } from 'react'
import { GET_ROUTE_POINT_BY_ID } from '../../../../../graphql/Catalog/Trucks/Routes/routesPoints'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { useQuery } from '@apollo/client'
import { arrayStatus } from '../../../../../const/constStatuses_waterTruckRequest'
import moment from 'moment'
import 'moment/locale/es'

const ProgressBarStatusTracker = ({ routePointInfo }) => {
  // console.log(routePointId, 'routePointId')
  const [infoRender, setInfoRender] = useState([])

  // const { loading, error, data } = useQuery(GET_ROUTE_POINT_BY_ID, {
  //   variables: {
  //     id: routePointId,
  //   },
  //   fetchPolicy: 'no-cache',
  // })

  useEffect(() => {
    try {
      const waterStation = routePointInfo.RoutePointsToWaterStation
      const waterTruckRequest = routePointInfo.RoutePointsToWaterTruckRequest
      const status_id = waterTruckRequest.status_id

      const loaded = routePointInfo.loaded_volume
      const delivered = routePointInfo.delivered_at

      const getArrayStatus = arrayStatus.find((item) => item.id === status_id)

      const generateArray = [
        {
          name: 'start',
          waterStation: waterStation.name,
          icon: 'fas fa-map-marker-alt',
          status:
            getArrayStatus.name === 'nuevo' ||
            getArrayStatus.name === 'planificar_pipa'
              ? 'is-active'
              : loaded
              ? 'is-complete'
              : '',
          //Enunciado
          showMessage: `Estación de agua - ${waterStation.name}`,
        },
        {
          name: 'loaded',
          value: routePointInfo.loaded_volume,
          icon: 'fas fa-tint',
          status:
            getArrayStatus.name === 'carga_pipa'
              ? 'is-active'
              : loaded
              ? 'is-complete'
              : '',
          showMessage: `Se cargo ${routePointInfo.loaded_volume} m³. ${moment(
            Number(routePointInfo.loaded_at)
          ).format('LLLL')}`,
        },
        {
          name: 'delivered',
          value: routePointInfo.delivered_at,
          icon: 'fas fa-water',
          status:
            getArrayStatus.name === 'entrega_pipa'
              ? 'is-active'
              : delivered
              ? 'is-complete'
              : '',
          showMessage: `Volumen entregado ${
            waterTruckRequest.volume
          } m³. ${moment(Number(routePointInfo.delivered_at, 'es-mx')).format(
            'LLLL'
          )}`,
        },
        {
          name: 'end',
          request: waterTruckRequest,
          icon: 'fas fa-check',
          status:
            loaded && delivered && getArrayStatus.name === 'completado'
              ? 'is-complete is-active'
              : '',
          showMessage: 'Entrega completada',
        },
      ]

      setInfoRender(generateArray)
    } catch (error) {
      console.log(error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [routePointInfo])

  return (
    <>
      <div className="col-lg-12 mt-2">
        <div className="card h-100 shadow-sm">
          <div
            className="card-body"
            style={{
              marginRight: '100px',
              marginLeft: '100px',
            }}
          >
            {' '}
            <ol className="progress-bar-status-tracking">
              {infoRender.length > 0 &&
                infoRender.map((point, index) => {
                  return (
                    <li key={index} className={point.status}>
                      <i className={`${point.icon} fa-2x`}></i>
                      {(point.status === 'is-active' ||
                        point.status === 'is-complete' ||
                        point.status === 'is-complete is-active') && (
                        <span
                          style={{
                            overflowWrap: 'break-word',
                          }}
                        >
                          <strong>{point.showMessage}</strong>
                        </span>
                      )}
                    </li>
                  )
                })}
            </ol>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProgressBarStatusTracker
